import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonFab, IonFabButton, IonIcon, IonButtons, IonButton, IonSpinner, IonItem, IonAvatar, IonLabel, IonLoading, IonSegment, IonSegmentButton } from '@ionic/react';
import { useState, useEffect, useRef } from 'react';
import { checkmark, chevronBack, remove } from 'ionicons/icons';
import { useHistory, useParams } from 'react-router';
import { getFile, updateFile } from '../firebase/firebaseStorage';
import dateFormat from 'dateformat';
import { getUser } from '../firebase/users';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Permissions from './Permissions';


const ImageViewer: React.FC<{}> = (props) => {
  const history = useHistory();
  const [image, setImage] = useState('');
  const [title, setTitle] = useState('');

  const [busy, setBusy] = useState(false);
  const [cropper, setCropper] = useState<Cropper>();
  const params: any = useParams();

  const imageRef = useRef<HTMLImageElement>(null);

  function getDateFromPath(path: string) {
    const slices = path.split('/');
    var n = slices[slices.length - 1];
    n = n.substring(0, 14);
    return n.substring(0, 4) + "-" + n.substring(4, 6) + "-" + n.substring(6, 8) + " " + n.substring(8, 10) + ":" + n.substring(10, 12);
  }

  function getUserIdFromPath(path: string) {
    const slices = path.split('_');
    var n = slices[slices.length - 1];
    return n.substring(0, n.indexOf("."));
  }

  useEffect(() => {
    setBusy(true);
    const path = params.url.replaceAll("-", "/");
    getFile(path).then((data) => {
      //console.log("ImageViewer", data);
      setImage(data?.url ?? "");

      var t = getDateFromPath(path);

      const u = getUser(getUserIdFromPath(path));
      if (u !== undefined) {
        t += " (" + u.initials + ")";
      }
      setTitle(t);
      // setTimeout(() => {
      // }, 500);


    })
  }, []);

  function confirm() {
    if (typeof cropper !== "undefined") {
      cropper.getCroppedCanvas().toBlob((data) => {
        //console.log(data);
        if (data !== null) {
          updateFile(params.url.replaceAll("-", "/"), data);
        }

        history.goBack();
      }, "image/jpeg", 0.7);

    }
  }



  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={history.goBack}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>{title}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => confirm()}><IonIcon icon={checkmark} /></IonButton>
          </IonButtons>
        </IonToolbar>

      </IonHeader>
      <IonLoading duration={0} isOpen={busy} />
      <IonContent fullscreen>
        <div style={{ height: "100%", width: "100%", padding: "5px" }} >
          {image !== "" ? <Cropper
            style={{ height: "100%", width: "100%" }}
            //initialAspectRatio={1}
            //preview=".img-preview"
            dragMode={"crop"}
            src={image}
            ref={imageRef}
            autoCropArea={1}
            autoCrop={true}
            viewMode={2}
            guides={false}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive={true}
            checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
            onInitialized={(instance: any) => {
              setCropper(instance);
              setBusy(false)

            }}
            onChange={(e) => {
              //console.log(e)
            }}

          /> : ""}
        </div>
      </IonContent>
    </IonPage >
  );
};

export default ImageViewer;
